import React from "react"
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { DialogBase, Props, State } from "./DialogBase";
import { TableComponent } from "./TableComponent";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from "primereact/multiselect";
import { buttonClassList } from "../../entities/Constants";

export class DialogForPagedSummaryListComponent extends DialogBase<Props, State> {

    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        const ele = this.props.ele;
        const summaryTypeOptions = [
            { value: 'SummaryList', label: 'Summary List', labelFRA: 'Summary List' },  // https://designsystem.ontario.ca/components/preview/summary-list.html
            { value: 'Table', label: 'Table', labelFRA: 'Table' },  // https://designsystem.ontario.ca/components/detail/tables.html
        ];
     
		const valueArray = Array.isArray(this.props.ele.BottomButtonClassName) ? this.props.ele.BottomButtonClassName : [];
        return (
            <Dialog
                header={"Paged Summary List Settings - " + (this.props.isEng ? ele.ENUTitle : ele.FRATitle)}
                footer={this.renderFooter(this.props)}
                visible={this.props.dialogVisible}
                style={{ width: '50vw' }}
                onHide={() => this.props.callback(false)}
            >
                <div>
                    {/* API URL */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"LovAPI_" + ele.Sequence}>API URL</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"LovAPI_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="e.g., /api/data"
                                value={ele.LovAPI || ''}
                                onChange={(e) => {
                                    ele.LovAPI = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Summary Type */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"SummaryType_" + ele.Sequence}>Summary Type</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Dropdown 
                                id={"SummaryType_" + ele.Sequence}
                                options={summaryTypeOptions} 
                                optionLabel={this.props.isEng ? 'label' : 'labelFRA'} 
                                optionValue='value' value={ele.SummaryType ?? ''}
                                onChange={(e) => {
                                    ele.SummaryType = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>               

                    {/* Page Size */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"PageSize_" + ele.Sequence}>Page Size (Row Count)</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"PageSize_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="10"
                                value={ele.PageSize?.toString() || '10'}
                                onChange={(e) => {
                                    const val = parseInt(e.target.value);
                                    ele.PageSize = isNaN(val) ? 10 : val;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Show Download Button */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowDownloadButton_" + ele.Sequence}>Show Download Button</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowDownloadButton_" + ele.Sequence}
                                checked={ele.ShowDownloadButton !== false}
                                onChange={(e) => {
                                    ele.ShowDownloadButton = e.checked;
                                    if(!e.checked){
                                        ele.DownloadTitle = '';
                                    }
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Show Download Title */}
                    {ele.ShowDownloadButton === true && (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"DownloadTitle_" + ele.Sequence}>Download Title</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"DownloadTitle_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="Enter Title"
                                value={ele.DownloadTitle || ''}
                                onChange={(e) => {
                                    ele.DownloadTitle = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    )}

                    {/* Show Total Count */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowTotalCount_" + ele.Sequence}>Show Total Count</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowTotalCount_" + ele.Sequence}
                                checked={ele.ShowTotalCount !== false}
                                onChange={(e) => {
                                    ele.ShowTotalCount = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Show Header Link */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowHeaderLink_" + ele.Sequence}>Show Header Link</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowHeaderLink_" + ele.Sequence}
                                checked={ele.ShowHeaderLink !== false}
                                onChange={(e) => {
                                    ele.ShowHeaderLink = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    {/* Header Link Text */}
                    {ele.ShowHeaderLink && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"HeaderLinkText_" + ele.Sequence}>Header Link Text</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"HeaderLinkText_" + ele.Sequence}
                                className="ontario-input"
                                value={ele.HeaderLinkText || ''}
                                onChange={(e) => {
                                    ele.HeaderLinkText = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}
                    {/* Show Link When Empty Data */}
                    {ele.ShowHeaderLink && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowLinkWhenEmpty_" + ele.Sequence}>Show Link When Empty Data</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowLinkWhenEmpty_" + ele.Sequence}
                                checked={ele.ShowLinkWhenEmpty === true}
                                onChange={(e) => {
                                    ele.ShowLinkWhenEmpty = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}
                    {/* Header Link Stepper-script */}
                    {ele.ShowHeaderLink && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"HeaderLinkStepperScript_" + ele.Sequence}>Header Link Stepper-script</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputTextarea
                                id={"HeaderLinkStepperScript_" + ele.Sequence}
                                className="ontario-input"
                                value={ele.HeaderLinkStepperScript}
                                onChange={(e) => {
                                    ele.HeaderLinkStepperScript = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}

                    {/* Show Item Link */}
                    {ele.SummaryType === 'Table' && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowItemLink_" + ele.Sequence}>Show Item Link</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowItemLink_" + ele.Sequence}
                                checked={ele.ShowItemLink !== false}
                                onChange={(e) => {
                                    ele.ShowItemLink = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}
                    {/* Item Link Text */}
                    {ele.ShowItemLink && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ItemLinkText_" + ele.Sequence}>Item Link Text</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"ItemLinkText_" + ele.Sequence}
                                className="ontario-input"
                                value={(this.props.isEng ? ele.ItemLinkText : ele.ItemLinkTextFRA) || ''}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        ele.ItemLinkText = e.target.value;
                                    } else {
                                        ele.ItemLinkTextFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}

                    {/* Show Bottom Button */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowBottomButton_" + ele.Sequence}>Show Bottom Button</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowBottomButton_" + ele.Sequence}
                                checked={ele.ShowBottomButton}
                                onChange={(e) => {
                                    ele.ShowBottomButton = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    {/* Bottom Button Class */}
                    {ele.ShowBottomButton && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"BottomButtonClassName_" + ele.Sequence}>Bottom Button Class</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <MultiSelect
                                id={"BottomButtonClassName_" + ele.Sequence}
                                options={buttonClassList}
                                optionLabel='label'
                                optionValue='val'
                                value={valueArray}
                                onChange={(e) => {
                                    this.props.ele.BottomButtonClassName = e.value;
                                    this.props.callback();
                                }}>                                    
                            </MultiSelect >
                        </div>
                    </div>}
                    {/* Bottom Button Label */}
                    {ele.ShowBottomButton && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"BottomButtonLabel_" + ele.Sequence}>Bottom Button Label</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"BottomButtonText_" + ele.Sequence}
                                className="ontario-input"
                                value={(this.props.isEng ? ele.BottomButtonLabel : ele.BottomButtonLabelFRA) || ''}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        ele.BottomButtonLabel = e.target.value;
                                    } else {
                                        ele.BottomButtonLabelFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}
                    {/* Bottom Button Stepper-script */}
                    {ele.ShowBottomButton && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"BottomButtonLabel_" + ele.Sequence}>Bottom Button Stepper Script</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputTextarea
                                id={"BottomButtonStepperScript_" + ele.Sequence}
                                className="ontario-input"
                                value={ele.BottomButtonStepperScript}
                                onChange={(e) => {
                                    ele.BottomButtonStepperScript = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}

                    {/* Client Side Pagination */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ClientSidePagination_" + ele.Sequence}>Client Side Pagination</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ClientSidePagination_" + ele.Sequence}
                                checked={ele.ClientSidePagination === true}
                                onChange={(e) => {
                                    ele.ClientSidePagination = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Client Side refresh on load */}
                    {ele.ClientSidePagination === true && <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"RefreshOnLoad_" + ele.Sequence}>Refresh on Load</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"RefreshOnLoad_" + ele.Sequence}
                                checked={ele.RefreshOnLoad === true}
                                onChange={(e) => {
                                    ele.RefreshOnLoad = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}

                    {/* Lazy Loading */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"LazyLoading_" + ele.Sequence}>Lazy Loading</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"LazyLoading_" + ele.Sequence}
                                checked={ele.LazyLoading === true}
                                onChange={(e) => {
                                    ele.LazyLoading = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Show Pagination */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"ShowPagination_" + ele.Sequence}>Show Pagination</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox
                                id={"ShowPagination_" + ele.Sequence}
                                checked={ele.ShowPagination !== false}
                                onChange={(e) => {
                                    ele.ShowPagination = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Data Path */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"DataPath_" + ele.Sequence}>Data Path</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"DataPath_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="e.g., content or data.items"
                                value={ele.DataPath || ''}
                                onChange={(e) => {
                                    ele.DataPath = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Total Count Path */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"TotalCountPath_" + ele.Sequence}>Total Count Path</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"TotalCountPath_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="e.g., totalCount"
                                value={ele.TotalCountPath || ''}
                                onChange={(e) => {
                                    ele.TotalCountPath = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Is Last Path */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"IsLastPath_" + ele.Sequence}>Is Last Path</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"IsLastPath_" + ele.Sequence}
                                className="ontario-input"
                                placeholder="e.g., last"
                                value={ele.IsLastPath || ''}
                                onChange={(e) => {
                                    ele.IsLastPath = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Table Empty Message */}
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"TableEmptyMessage_" + ele.Sequence}>Empty Message</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputText
                                id={"TableEmptyMessage_" + ele.Sequence}
                                className="ontario-input"
                                placeholder={this.props.isEng ? "No records found." : "Aucun enregistrement trouvé."}
                                value={(this.props.isEng ? ele.TableEmptyMessage : ele.TableEmptyMessageFRA) || ''}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        ele.TableEmptyMessage = e.target.value;
                                    } else {
                                        ele.TableEmptyMessageFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {/* Column Configuration */}
                    <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Column Configuration</div>
                        <TableComponent
                            ele={ele}
                            isEng={this.props.isEng}
                            callback={() => this.props.callback()}
                            showMoveButtons={true}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }

    render() {
        return this.generateHtmlString();
    }
}